import 'antd/dist/reset.css';
import './styles/roboto.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/App.css';
import ErrorBoundary from './components/ErrorBoundary';
import { AppConfigProvider } from './context/AppConfigContext';
import process from 'process';

// Polyfill for process
window.process = process;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppConfigProvider>
        <App />
      </AppConfigProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
